import { Outlet } from "react-router-dom";
import "./App.css";
import GlobalHeader from "./components/header/globalHeader/GlobalHeader";
import Footer from "./components/footer/Footer";

function App() {
  return (
    <div className="min-h-screen min-w-[320px] flex justify-between flex-col font-nunito text-lg sm:text-xl">
      <div className="relative min-h-[90vh] sm:min-h-[93vh]">
        <GlobalHeader />
        <Outlet />
      </div>
      <Footer />
    </div>
  )
}

export default App